export default __webpack_public_path__ + "static/media/business-background-3.55f34861.webp";